(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rr-story-portrait-decoder')) {
    customElements.define('rr-story-portrait-decoder', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        const image = this.closest('.shopify-section--slideshow')?.querySelector('picture img');
        image?.decode?.().catch(() => {});
      }
    });
  }
  if (!customElements.get('rr-hero-bottom-handoff')) {
    customElements.define('rr-hero-bottom-handoff', class extends HTMLElement {
      connectedCallback() {
        this.hero = this.closest('.shopify-section--slideshow');
        if (this.hero !== document.querySelector('#main > .shopify-section--slideshow')) return;
        this.abort = new AbortController();
        this.lastOpacity = null;
        this.offscreenAbove = false;
        this.visibility = new IntersectionObserver(([entry]) => {
          this.offscreenAbove = entry.boundingClientRect.bottom <= 0;
          this.update();
        });
        this.visibility.observe(this.hero);
        const schedule = () => {
          if (this.offscreenAbove || this.frame != null) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        };
        window.addEventListener('scroll', schedule, { passive: true, signal: this.abort.signal });
        window.addEventListener('resize', schedule, { passive: true, signal: this.abort.signal });
        window.addEventListener('pageshow', schedule, { signal: this.abort.signal });
        this.resize = new ResizeObserver(schedule);
        this.resize.observe(this.hero);
        this.update();
      }
      update() {
        let opacity = 1;
        if (!this.offscreenAbove) {
          const depth = parseFloat(getComputedStyle(document.body, '::before').height) || 1;
          const bottom = this.hero.getBoundingClientRect().bottom;
          opacity = Math.min(1, Math.max(0, (window.innerHeight - bottom) / depth));
        }
        const value = opacity.toFixed(4);
        if (value === this.lastOpacity) return;
        this.lastOpacity = value;
        document.body.style.setProperty('--rr-hero-bottom-opacity', value);
        document.body.classList.add('rr-hero-bottom-handoff');
      }
      disconnectedCallback() {
        if (!this.abort) return;
        this.abort.abort();
        this.resize.disconnect();
        this.visibility.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = null;
        document.body.classList.remove('rr-hero-bottom-handoff');
        document.body.style.removeProperty('--rr-hero-bottom-opacity');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
